{
  "process_creation": {
    "name": "Process Creation",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "process_path",
        "process_name",
        "process_cmdline",
        "parent_process_path",
        "parent_process_cmdline",
        "md5",
        "sha256",
        "username",
        "hostname"
      ],
      "endpoint:wineventlog": [
        "process_path",
        "process_name",
        "process_cmdline",
        "parent_process_path",
        "username",
        "hostname"
      ]
    }
  },
  "file_event": {
    "name": "File Event",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "target_path",
        "process_path",
        "process_name",
        "username",
        "hostname"
      ],
      "endpoint:wineventlog": [
        "target_path",
        "username",
        "hostname"
      ]
    }
  },
  "network_connection": {
    "name": "Network Connection",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "process_path",
        "process_name",
        "dest_ip",
        "dest_port",
        "src_ip",
        "username",
        "hostname"
      ],
      "network": [
        "src_ip",
        "dest_ip",
        "dest_port"
      ],
      "web": [
        "url",
        "domain",
        "dest_ip"
      ],
      "http": [
        "url",
        "domain",
        "dest_ip"
      ]
    }
  },
  "registry_event": {
    "name": "Registry Event",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "registry_path",
        "process_path",
        "process_name",
        "username",
        "hostname"
      ],
      "endpoint:wineventlog": [
        "registry_path",
        "username",
        "hostname"
      ]
    }
  },
  "dns": {
    "name": "DNS",
    "ccm_log_categories": {
      "dns": [
        "dns_query",
        "dns_answer",
        "src_ip"
      ],
      "endpoint:sysmon": [
        "dns_query",
        "dns_answer",
        "process_path",
        "process_name",
        "hostname"
      ]
    }
  },
  "image_load": {
    "name": "Image Load",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "object_loaded",
        "process_path",
        "process_name",
        "md5",
        "sha256",
        "hostname"
      ]
    }
  },
  "authentication_events": {
    "name": "Authentication Events",
    "ccm_log_categories": {
      "endpoint:wineventlog": [
        "username",
        "hostname",
        "src_ip",
        "logon_type"
      ]
    }
  },
  "pipe_created": {
    "name": "Pipe Created",
    "ccm_log_categories": {
      "endpoint:sysmon": [
        "pipe_name",
        "process_path",
        "process_name",
        "hostname"
      ]
    }
  },
  "security": {
    "name": "Security",
    "ccm_log_categories": {
      "endpoint:wineventlog": [
        "username",
        "hostname",
        "event_id"
      ]
    }
  },
  "system": {
    "name": "System",
    "ccm_log_categories": {
      "endpoint:wineventlog": [
        "hostname",
        "event_id"
      ]
    }
  },
  "cloud": {
    "name": "Cloud",
    "ccm_log_categories": {
      "cloud": [
        "username",
        "src_ip"
      ]
    }
  },
  "firewall": {
    "name": "Firewall",
    "ccm_log_categories": {
      "network": [
        "src_ip",
        "dest_ip",
        "dest_port",
        "protocol"
      ]
    }
  },
  "proxy": {
    "name": "Proxy",
    "ccm_log_categories": {
      "http": [
        "url",
        "domain",
        "src_ip",
        "dest_ip"
      ],
      "web": [
        "url",
        "domain",
        "src_ip",
        "dest_ip"
      ]
    }
  },
  "Rdp_event": {
    "name": "RDP Event",
    "ccm_log_categories": {
      "endpoint:wineventlog": [
        "username",
        "hostname",
        "src_ip"
      ]
    }
  },
  "application": {
    "name": "Application",
    "ccm_log_categories": {
      "endpoint:wineventlog": [
        "hostname",
        "event_id"
      ]
    }
  },
  "webserver": {
    "name": "Web Server",
    "ccm_log_categories": {
      "web": [
        "url",
        "domain",
        "src_ip"
      ],
      "http": [
        "url",
        "domain",
        "src_ip"
      ]
    }
  }
}
